import { MarketPlaceType } from "@vahak/core/dist/constants/market";
import { ROUTES } from "@vahak/core/dist/constants/routeStrings";

export const MARKETPLACE_ROUTE_CONFIG = {
    loadUrl: ROUTES.marketplace.getUrl(MarketPlaceType.LOAD),
    loadType: MarketPlaceType.LOAD,
    lorryUrl: ROUTES.marketplace.getUrl(MarketPlaceType.LORRY),
    lorryType: MarketPlaceType.LORRY
} as const;

export const MARKETPLACE_ANY_DESTINATION_ID = -1;

/** ISR cache for static shells — shell is i18n + URL props only; listings fetch client-side. */
export const MARKETPLACE_ISR_REVALIDATE_SECONDS = 7 * 24 * 60 * 60;

export const TRANSPORT_DIRECTORY_ISR_REVALIDATE_SECONDS = MARKETPLACE_ISR_REVALIDATE_SECONDS;

/** Consumer `/marketplace/*` routes. */
export function isConsumerMarketplacePath(pathname: string) {
    return pathname.includes("/marketplace") && !pathname.includes("/tso/");
}
